<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_managebusinessnew/_update/updateBusiness.vue'
export default {
  components: {
    createContent
  }
}
</script>
